<div class="header">
    <search-header #header
                   [dashboardName]="dashboardName"
                   [index]="index"
                   [dashboardFiltersConfiguration]="dashboardFiltersConfiguration"
                   [dashboardCriteriaConfiguration]="dashboardCriteriaConfiguration"
                   (refreshData)="search()"></search-header>
</div>

<notification type="error" *ngIf="displayError">
    {{errorString}}
</notification>
<div class="container" *ngIf="!displayError">
    <div *ngFor="let line of config" class="row">
        <div *ngFor="let graph of line"
             class="defaultGraphParam"
             [class]="graph.class ? graph.class : defaultClass"
             [ngSwitch]="graph.type">
            <line-graph *ngSwitchCase="graphType.LINE"
                        class="child"
                        #line
                        [index]="index"
                        [config]="graph"></line-graph>

            <bar-graph *ngSwitchCase="graphType.BAR"
                       class="child"
                       #bar
                       [index]="index"
                       [config]="graph"></bar-graph>
            <multiple-bar-graph *ngSwitchCase="graphType.MULTIPLE_BAR"
                       class="child"
                       #multipleBar
                       [index]="index"
                       [config]="graph"></multiple-bar-graph>

            <rotatebar-graph *ngSwitchCase="graphType.ROTATEBAR"
                             class="child"
                             #rotatebar
                             [index]="index"
                             [config]="graph"></rotatebar-graph>

            <sunburst-graph *ngSwitchCase="graphType.SUNBURST"
                            class="child"
                            #sunburst
                            [index]="index"
                            [config]="graph"></sunburst-graph>

            <number-graph *ngSwitchCase="graphType.NUMBER"
                          class="child"
                          #number
                          [index]="index"
                          [config]="graph"></number-graph>

            <div *ngSwitchDefault>
                <h6>{{wording.noType}}</h6>
            </div>
        </div>
    </div>
</div>
